<template>
    <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" :rows="rows" />
</template>

<script>
/*
    Lima Bean based this off of https://github.com/imperavi/vue-redactor


    Redactor Vue Component
    Version 1.1
    Updated: March 25, 2020

    http://imperavi.com/redactor/

    Copyright 2020, Imperavi Ltd.
    License: MIT
*/
export default {
    redactor: false,
    props: {
        value: {
            default: '',
            type: String
        },
        placeholder: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        rows: {
            type: String,
            default: "4"
        },
        config: {
            type: Object,
            default: () => {
                return {
                    minHeight: '100px',
                    plugins: [
                        'alignment', 'table', 'fullscreen', 'limiter',
                        'counter', 'specialchars', 'fontcolor', //'video'
                    ],
                    imageUpload: '/api/redactor-upload.json',
                    imageUploadMultiple: '/api/redactor-upload-multiple.json',
                    imageResizable: true,
                    imagePosition: true,
                    callbacks: {
                        uploadBeforeSend: xhr => {
                            let token = Cookies.get('csrfToken');
                            if (token) {
                                xhr.setRequestHeader('X-CSRF-Token', token);
                            }
                        }
                    }
                }
            }
        }
    },
    watch: {
        value(newValue, oldValue){
            if (!this.redactor.editor.isFocus())
                this.redactor.source.setCode(newValue);
        }
    },
    mounted() {
        const interval = setInterval(() => {
            if (window.Redactor) {
                this.init();
                clearInterval(interval);
            }
        }, 100);
    },
    beforeDestroy() {
        this.destroy()
    },
    methods: {
        init () {
            var me = this;
            var callbacks = {
                changed: function(html) {
                    me.handleInput(html);
                    return html
                }
            };

            // extend config
            if (typeof this.config.callbacks === 'undefined') {
                Vue.set(this.config, 'callbacks', callbacks);
            }
            else {
                this.config.callbacks.changed = callbacks.changed;
            }

            // call Redactor
            let app = Redactor(this.$refs.redactor, this.config);

            // set instance
            this.redactor = app;
            this.$parent.redactor = app;
        },
        destroy () {
            // Call destroy on redactor to cleanup event handlers
            Redactor(this.$refs.redactor, 'destroy');

            // unset instance for garbage collection
            this.redactor = null;
            this.$parent.redactor = null;
        },
        handleInput (val) {
            this.$emit('input', val);
        }
    }
}
</script>
